import * as ReactRedux from 'react-redux';
import HeaderComponent from './HeaderComponent';
import { AppState } from '../app/app.types';
import { signout } from '../auth/auth.actions';
import { paths } from '../app/app.routes';
import { push } from 'react-router-redux';
import {
  REVERT_TO_INITIAL_STATE,
  REVERT_TO_INITIAL_STATE_EXCEPT_AUTH
} from '../app/app.const';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    toLogin: () => dispatch(push(paths.login)),
    onClickLogout: () => dispatch(signout()),
    toMyInfo: () => dispatch(push(paths.myInfo)),
    revertToInitialState: () => dispatch({type: REVERT_TO_INITIAL_STATE}),
    revertToInitialStateExceptAuth: () => dispatch({type: REVERT_TO_INITIAL_STATE_EXCEPT_AUTH}),
    toBusinessInfo: () => dispatch(push(paths.businessInfo)),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    toServiceAgreement: () => dispatch(push(paths.serviceAgreement))
  };
};

const mapStateToProps = (state: AppState, ownProps) => {
  return {
    businessState: state.businessState,
    authState: state.authState,
    adminState: state.adminState,
    toggleSidebarHandler: ownProps.toggleSidebarHandler
  };
};

const Header = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);

export default Header;



// WEBPACK FOOTER //
// ./src/header/Header.tsx